import get from 'lodash/get.js';

class ActivityHelper {
    namespace(string) {
        return string.substring(0, string.indexOf('/'));
    }

    valid(activity) {
        return !!activity.activity_content.quiz_id && !!activity.title;
    }

    checkForZeroTimeLimit(activity) {
        const timeLimit = get(activity, 'activity_content.time_limit');

        if (Number(timeLimit) === 0) {
            activity.activity_content.time_limit = null;
        }

        return activity;
    }

    saveQuizActivity(store, mutation) {
        const activity = store.getters[`${this.namespace(mutation.type)}/get`](mutation.payload.target);

        if (!this.valid(activity)) return;

        this.checkForZeroTimeLimit(activity);

        store.dispatch('AutoSave/setSaving', mutation);

        store
            .dispatch('AutoSave/activities', {
                mutation: mutation.type,
                activity,
            })
            .then(() => {
                store.dispatch('AutoSave/setSaved', mutation);
            });
    }

    validateActivitySettings({ settings, mutation }) {
        const { field } = mutation.payload;

        const dueAt = this.validateField(field, 'due', 'allow_submissions_after_due_date');

        const visibleAt = this.validateField(field, 'visible', 'remove_visible_at');

        const dueDatesValid = this.validateSettings(settings, ['week_due', 'day_due', 'time_due']);

        const visibleAtValid = this.validateSettings(settings, ['week_visible', 'day_visible', 'time_visible']);

        if (dueAt) return dueDatesValid;

        if (visibleAt) return visibleAtValid;

        return true;
    }

    validateSettings(activitySettings, settings) {
        return settings.every(key => activitySettings[key]);
    }

    validateField(field, type, check) {
        return field.includes(type) && field !== check;
    }
}

export default ActivityHelper;
